export const SUPPORT_TEAM_TYPES = {
  CLINICAL_OPERATIONS: 'Clinical Operations',
  PHARMACY: 'Pharmacy',
  PROVIDER_SERVICES: 'Provider Services'
};

export const PROMPT_TEXTS = {
  TOPIC_SELECTION: 'What would you like to chat about?',
  SUPPORT_TEAM_SELECTION: 'Before beginning your chat session, please select the support team you would like to chat with.'
};
